import 'moment';
import 'humanize-duration';
import 'angular-timer/dist/angular-timer.min';
require('./assets/javascripts/angular-toastr/dist/angular-toastr.min.js');
require('./assets/javascripts/angular-toastr/dist/angular-toastr.tpls.min.js');
require('./assets/javascripts/gsap/src/minified/TweenMax.min.js');
require('./assets/javascripts/ngFx/ngFx.min.js');